module.exports = __webpack_public_path__ + "img/teatro cousino.d47e6656.jpg";